'use strict';

module.exports = {
  foo: 'bar'
};